// @ts-nocheck

import type { BetBuilderRootState, BetBuilderState } from '../states/betbuilder';
import { BetBuilderActionTypes } from '../types/actions/betbuilder';
import { BetBuilderStatuses, BetBuilderSelectionStatuses } from '../types/betbuilder';
import type { BetBuilderAction } from '../types/betbuilder';
import createReducer from '../utils/createReducer';

export const betbuilderInitialState: BetBuilderState = {
  selection: {
    items: [],
    value: null,
    status: BetBuilderSelectionStatuses.EMPTY,
    error: null,
    ecode: null,
  },
  betTypesList: [],
  betTypes: {},
  status: BetBuilderStatuses.INIT,
  error: null,
  ecode: null,
};

const clearSelection = (state) => {
  return { ...state, selection: betbuilderInitialState.selection, source: undefined };
};

// Initial Reducer
export const matchReducer = createReducer(betbuilderInitialState, {
  [BetBuilderActionTypes.CLEAR_SELECTION]: clearSelection,
});

const actionTypesValues = Object.keys(BetBuilderActionTypes).map((key) => BetBuilderActionTypes[key]);

export default (state: BetBuilderRootState = { matches: {} }, action: BetBuilderAction, rootState: unknown) => {
  if (-1 !== actionTypesValues.indexOf(action.type)) {
    const { matchId } = action.payload;
    if (matchId) {
      return {
        ...state,
        matches: {
          ...state.matches,
          [matchId]: matchReducer(state.matches[matchId], action, rootState),
        },
      };
    }
  }
  return state;
};
